import { AppState } from 'src/app/store'

export const campaingsStateSelector = (state: AppState) => state.vouchers.campaings
export const createCampaingStateSelector = (state: AppState) => state.vouchers.createCampaign
export const createDiscountVoucherSelector = (state: AppState) => state.vouchers.createDiscountVoucher
